import { render, staticRenderFns } from "./SettingAdvanced.vue?vue&type=template&id=12e2e691&scoped=true"
import script from "./SettingAdvanced.vue?vue&type=script&lang=ts"
export * from "./SettingAdvanced.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2e691",
  null
  
)

export default component.exports